<template lang='pug'>
v-dialog(v-model='visible', @keydown.esc='cancel', :persistent='true')
  v-card.confirm-dialog
    v-card-title {{ title }}
    v-card-text(v-show='!!message')
      pre {{ message }}
    v-card-actions
      v-spacer
      v-btn(text, @click.native='agree') OK
      v-btn(text, @click.native='cancel') Cancel
</template>

<style lang="less">
.confirm-dialog {
  .v-card__title {
    background-color: #e7f5f8;
    border-bottom: solid 1px #179bb5;
  }
  .v-card__text {
    padding: 20px 20px 20px 20px !important;
    pre {
      font-family: Poppins;
      font-size: 17px;
    }
  }
}
</style>

<script>
export default {
  data: () => ({
    visible: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 290,
      zIndex: 200
    }
  }),
  methods: {
    open (title, message, options) {
      this.visible = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.visible = false
    },
    cancel () {
      this.resolve(false)
      this.visible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/confirm.vue